import {useEffect, useState} from 'react';
import {useNavigate} from 'react-router-dom';
import UtilisateurService from '../services/UtilisateurService';

const AccessGuard = ({children}) => {
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const checkAuth = async () => {
            try {
                const authenticated = await UtilisateurService.checkAuthentication();
                if (!authenticated) {
                    navigate('/authentication/sign-in');
                }
            } catch (error) {
                console.error(
                    "Erreur lors de la vérification de l'authentification",
                    error
                );
                navigate('/authentication/sign-in');
            } finally {
                setIsLoading(false);
            }
        };

        checkAuth();
    }, [navigate]);

    if (isLoading) {
        // Vous pouvez rendre ici un composant de chargement ou simplement retourner null pour ne rien afficher
        return null;
    }

    return children;
};

export default AccessGuard;
